export default "__VITE_ASSET__9fb868e7__"